import {Box, Table, TableBody, TableCell as MuiTableCell, TableHead, TableRow} from "@material-ui/core";
import moment from "moment";
import i18n from "i18next";
import React, {FC} from "react";
import styled from "styled-components/macro";
import {useTranslation} from "react-i18next";
import {LogEntry} from "../../../../../../../../models/LogEntry";
import CustomAvatar from "./CustomAvatar";

const StyledTableCell = styled(MuiTableCell)(() => ({
  color: '#A1A1A1',
}));

const TableCell = styled(MuiTableCell)(() => ({
  '-webkit-text-size-adjust': 'none',
}))

type SpanProps = {
  ml?: number,
}

const CustomSpan = styled.span<SpanProps>`
  text-transform: capitalize;
  ${((props) => props.ml ? `margin-left: ${props.ml}px` : null)}
`

type PropsType = {
  data: LogEntry[]
}

const HistoryTable: FC<PropsType> = ({data}) => {
  const { t } = useTranslation()

  const getUserCell = (user: any) => {
    const data = {
      name: user ? `${user.first_name} ${user.last_name}` : 'Admin',
      email: user ? user.email : ''
    }
    return (
      <Box display='flex'>
        <CustomAvatar src={user?.picture} name={data.name}/>
        <Box ml={2} display={'flex'} flexDirection={'column'} justifyContent={'center'}>
          <p style={{fontWeight: 500}}>{data.name}</p>
          {data.email && <p style={{color: '#A1A1A1'}}>{data.email}</p>}
        </Box>
      </Box>
    )
  }

  const parseMessage = (messages: string) => {
    return JSON.parse(messages).map((message: any, indexMessage: number) => {
      let result: any[] = []
      const parentKeys = Object.keys(message)
      if (parentKeys.length > 0) {
        parentKeys.map((parentKey) => {
          result.push(<CustomSpan key={parentKey}>{parentKey}</CustomSpan>)
          const childrenKeys = Object.keys(message[parentKey])
          if (childrenKeys.length > 0) {
            childrenKeys.map((childrenKey) => {
              if (childrenKey !== 'object') {
                if (typeof message[parentKey][childrenKey] === 'object') {
                  result.push(
                    <CustomSpan key={childrenKey}>
                      <CustomSpan> {childrenKey}</CustomSpan>:
                      <CustomSpan ml={5}>
                        {message[parentKey][childrenKey].join(', ')}
                      </CustomSpan>
                    </CustomSpan>)
                } else {
                  result.push(
                    <CustomSpan key={childrenKey}>
                      <CustomSpan> {childrenKey}</CustomSpan>:
                      <CustomSpan ml={5}>
                        {message[parentKey][childrenKey]}
                      </CustomSpan>
                    </CustomSpan>
                  )
                }
              }
            })

          }
        })
      }
      return <p style={{fontWeight: 500}} key={indexMessage}>{result}</p>
    })
  }

  return (
    <Table style={{width: '100%', minWidth: '1000px'}}>
      <TableHead style={{position: 'sticky', top: 0, background: '#FFF', zIndex: 1}}>
        <TableRow>
          <StyledTableCell>{t('changed_by')}</StyledTableCell>
          <StyledTableCell>{t('published')}</StyledTableCell>
          <StyledTableCell align="left">{t('activity')}</StyledTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((item, index) => (
          <TableRow key={index}>
            <TableCell component="th" scope="row">{getUserCell(item.user)}</TableCell>
            <TableCell>
              <p style={{fontWeight: 500}}>{moment(item.action_time).locale(i18n.language).format('LLL')}</p>
              <p style={{color: '#A1A1A1'}}>{moment(item.action_time).locale(i18n.language).format('dddd')}</p>
            </TableCell>
            <TableCell align="left">{parseMessage(item.change_message)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default HistoryTable